import AboutCourses from './AboutCourses';

export { AboutCourses };
export default AboutCourses;
